module.exports = __webpack_public_path__ + "static/media/profile.ca5e9baa.jpg";